<template>
  <v-card>
    <v-card-title>Ожидание подключения</v-card-title>
    <v-card-text>
      <appeals-connection-pending />
    </v-card-text>
    <v-card-actions v-if="showAdminActions">
      <v-row v-if="extraInfo">
        <v-col>
            <v-btn
                v-if="operationDetailsLink"
                :href="operationDetailsLink"
                target="_blank"
                color="primary"
            >
                Подробнее о процессе подключения
            </v-btn>
        </v-col>
      </v-row>

      <v-row v-if="extraInfo">
        <v-col>
            <pre>{{ JSON.stringify(extraInfo, null, 2) }}</pre>
        </v-col>
      </v-row>
    </v-card-actions>
  </v-card>
</template>

<script>
import AppealsConnectionPending from '@/app/components/appeals/AppealsConnectionPending.vue';
import { mapGetters } from 'vuex';
export default {
  methods: {
  },
  name: 'AppealsConnectionPendingPage',
  components: {
    AppealsConnectionPending
  },
    watch: {
        statusConnection: {
            handler(newVal) {
                if (newVal === 'CONNECTED') {
                    setTimeout(() => {
                        this.$router.push({ name: 'appeals.list'});
                    }, 2000);
                }
                if (newVal === 'DISCONNECTED') {
                    setTimeout(() => {
                        this.$router.push({ name: 'appeals.connect'});
                    }, 2000);
                }
            },
            immediate: true,
            flush: 'post'
        }
    },
  computed: {
    ...mapGetters('organization', ['appealsServiceConnection']),
    ...mapGetters( 'user', ['HAS_ROLE']),
    operationDetailsLink(){
        if (this.appealsServiceConnection?.extra?.connection?.gisRequest?.externalOperationId) {
            return `https://coreui.ais24.ru/operations/${this.appealsServiceConnection.extra.connection.gisRequest.externalOperationId}`;
        }
        return null;
    },
    extraInfo(){
        return this.appealsServiceConnection?.extra;
    },
    showAdminActions(){
        return (this.HAS_ROLE('admin') || this.HAS_ROLE('manager'));
    },
    statusConnection(){
        return this.appealsServiceConnection?.status;
    }
  },
}
</script>
